@if (hasChartData()) {
  <div class="position-relative mx-auto" style="height:60vh">
    <canvas baseChart
      [data]="lineChartData()"
      [options]="lineChartOptions()"
      [type]="'line'"></canvas>
  </div>
} @else {
  <op-no-results />
}

@if (isDevMode) {
  <hr/>

  <details>
    <summary>Debug</summary>
    <code>
      <pre>{{maxValue() }}</pre>
      <pre>{{lineChartData() | json}}</pre>
    </code>
  </details>
}
